import { render, staticRenderFns } from "./normal.vue?vue&type=template&id=f5e10674&scoped=true&"
import script from "./normal.vue?vue&type=script&lang=ts&"
export * from "./normal.vue?vue&type=script&lang=ts&"
import style0 from "./normal.vue?vue&type=style&index=0&id=f5e10674&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e10674",
  null
  
)

export default component.exports